import EFPicture from 'elem/compCommon/EFPicture';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { useRef, useEffect, useState, Fragment } from 'react';
import { Tooltip } from 'antd';
import { comingSoonTime } from '../..';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getSolarRecommand } from '@/service/solar-calculator';

const ICON_1 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
        <g className="svg-g">
            <rect width="100%" height="100%" rx="12" fill="#38383D" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.24129 12.545H15.7516C15.9291 12.545 16.0749 12.4939 16.1889 12.3916C16.303 12.2893 16.3601 12.1586 16.3601 11.9996C16.3601 11.8405 16.303 11.7098 16.1889 11.6075C16.0749 11.5052 15.9291 11.4541 15.7516 11.4541H8.24129C8.06381 11.4541 7.91804 11.5052 7.80395 11.6075C7.68986 11.7098 7.63281 11.8405 7.63281 11.9996C7.63281 12.1586 7.68986 12.2893 7.80395 12.3916C7.91804 12.4939 8.06381 12.545 8.24129 12.545Z"
                fill="#E6E6E6"
            />
        </g>
    </svg>
);

const ICON_2 = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 24 24" fill="none">
        <g className="svg-g">
            <rect width="100%" height="100%" rx="12" fill="#38383D" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.24129 12.6088H11.388V15.7555C11.388 15.933 11.445 16.0788 11.5591 16.1929C11.6732 16.3069 11.819 16.364 11.9964 16.364C12.1739 16.364 12.3197 16.3069 12.4338 16.1929C12.5479 16.0788 12.6049 15.933 12.6049 15.7555V12.6088H15.7516C15.9291 12.6088 16.0749 12.5518 16.1889 12.4377C16.303 12.3236 16.3601 12.1778 16.3601 12.0004C16.3601 11.8229 16.303 11.6771 16.1889 11.563C16.0749 11.4489 15.9291 11.3919 15.7516 11.3919H12.6049V8.24519C12.6049 8.06772 12.5479 7.92194 12.4338 7.80785C12.3197 7.69376 12.1739 7.63672 11.9964 7.63672C11.819 7.63672 11.6732 7.69376 11.5591 7.80785C11.445 7.92194 11.388 8.06772 11.388 8.24519V11.3919H8.24129C8.06381 11.3919 7.91804 11.4489 7.80395 11.563C7.68986 11.6771 7.63281 11.8229 7.63281 12.0004C7.63281 12.1778 7.68986 12.3236 7.80395 12.4377C7.91804 12.5518 8.06381 12.6088 8.24129 12.6088Z"
                fill="#E6E6E6"
            />
        </g>
    </svg>
);

const ICON_AU = () => (
    <svg className="install-icon" xmlns="http://www.w3.org/2000/svg" width="76" height="15" viewBox="0 0 76 15" fill="none">
        <path
            d="M6.25502 7.34824C6.25502 6.06715 5.29569 5.16725 4.11696 5.16725C2.93822 5.16725 1.97889 6.08282 1.97889 7.34824C1.97889 8.59869 2.93822 9.52851 4.11696 9.52851C5.29712 9.52851 6.25502 8.62932 6.25502 7.34824ZM6.27223 11.1601V10.1691C5.69075 10.8552 4.82462 11.2813 3.78857 11.2813C1.63474 11.2813 0 9.60403 0 7.34824C0 5.10669 1.69711 3.39952 3.83661 3.39952C4.84327 3.39952 5.69146 3.82702 6.27294 4.49678V3.53632H8.20667V11.1601H6.27223ZM17.5978 9.46723C16.921 9.46723 16.7331 9.22355 16.7331 8.58372V5.1986H17.9756V3.53561H16.7331V1.67597H14.7513V3.53561H12.1989V3.07248C12.1989 2.43122 12.4512 2.18683 13.1431 2.18683H13.5776V0.70838H12.624C10.9893 0.70838 10.2193 1.22709 10.2193 2.81241V3.5349H9.11868V5.1986H10.2193V11.1594H12.201V5.1986H14.7535V8.93428C14.7535 10.4897 15.3658 11.1609 16.969 11.1609H17.9914V9.46795H17.5971L17.5978 9.46723ZM24.7039 6.66138C24.5626 5.67099 23.7288 5.07605 22.7544 5.07605C21.7793 5.07605 20.9777 5.65532 20.7741 6.66138H24.7032H24.7039ZM20.7576 7.85127C20.8995 8.97917 21.7327 9.62042 22.7859 9.62042C23.6191 9.62042 24.2644 9.23852 24.6408 8.62861H26.6699C26.1974 10.2446 24.7039 11.2813 22.7386 11.2813C20.3654 11.2813 18.6991 9.66602 18.6991 7.3632C18.6991 5.06109 20.46 3.39881 22.7874 3.39881C25.1298 3.39881 26.8269 5.07605 26.8269 7.3632C26.8269 7.53135 26.8118 7.69808 26.7803 7.85127H20.7576ZM39.4251 7.34824C39.4251 6.11275 38.4658 5.16725 37.2871 5.16725C36.1083 5.16725 35.149 6.08282 35.149 7.34824C35.149 8.59869 36.1083 9.52851 37.2871 9.52851C38.4658 9.52851 39.4251 8.58372 39.4251 7.34824ZM33.1988 3.53632H35.1325V4.52742C35.7133 3.8256 36.5779 3.39952 37.6161 3.39952C39.7384 3.39952 41.404 5.09244 41.404 7.33256C41.404 9.57482 39.7069 11.2827 37.5688 11.2827C36.5779 11.2827 35.7606 10.9008 35.1956 10.261V14.2973H33.1988V3.53632ZM48.3731 7.34824C48.3731 6.06715 47.4152 5.16725 46.2351 5.16725C45.0564 5.16725 44.097 6.08282 44.097 7.34824C44.097 8.59869 45.0564 9.52851 46.2351 9.52851C47.4152 9.52851 48.3731 8.62932 48.3731 7.34824ZM48.3904 11.1601V10.1691C47.8089 10.8552 46.9428 11.2813 45.9067 11.2813C43.7529 11.2813 42.1181 9.60403 42.1181 7.34824C42.1181 5.10669 43.8152 3.39952 45.954 3.39952C46.96 3.39952 47.8089 3.82702 48.3904 4.49678V3.53632H50.3234V11.1601H48.3904ZM29.7142 4.28374C29.7142 4.28374 30.2061 3.40023 31.4113 3.40023C31.9268 3.40023 32.2602 3.57123 32.2602 3.57123V5.51638C32.2602 5.51638 31.5332 5.08104 30.865 5.16868C30.1967 5.25631 29.7744 5.85126 29.7766 6.64784V11.1616H27.7805V3.53775H29.7142V4.28374ZM59.3531 3.53632L54.4719 14.2731H52.4134L54.3299 10.122L51.0891 3.53632H53.4222L55.3179 7.93677L57.2631 3.53632H59.3531ZM74.9355 3.36318L70.0958 0.654942C68.6761 -0.140216 66.9002 0.853019 66.9002 2.44476V2.72264C66.9002 2.97344 67.0385 3.20572 67.2622 3.33041L68.1764 3.84199C68.4446 3.99304 68.7787 3.80494 68.7787 3.50497V2.81384C68.7787 2.46827 69.1644 2.25167 69.4727 2.42481L73.6642 4.77181C73.9725 4.94424 73.9725 5.37602 73.6642 5.54844L69.4727 7.89473C69.1644 8.06716 68.7794 7.85198 68.7794 7.5057V7.13805C68.7794 5.54702 67.0034 4.55164 65.5816 5.34823L60.7419 8.05718C60.4193 8.2333 60.1501 8.49234 59.9627 8.80719C59.7752 9.12205 59.6763 9.48116 59.6763 9.847C59.6763 10.2128 59.7752 10.572 59.9627 10.8868C60.1501 11.2017 60.4193 11.4607 60.7419 11.6368L65.5816 14.3451C67.002 15.1402 68.7794 14.147 68.7794 12.5552V12.2774C68.7786 12.1532 68.7445 12.0315 68.6808 11.9247C68.617 11.8179 68.5259 11.7298 68.4166 11.6696L67.5032 11.1566C67.235 11.0062 66.9002 11.1944 66.9002 11.4943V12.1854C66.9002 12.531 66.5144 12.7469 66.2068 12.5738L62.0146 10.2275C61.9446 10.1891 61.8863 10.1328 61.8457 10.0645C61.8051 9.99612 61.7837 9.91819 61.7837 9.83881C61.7837 9.75942 61.8051 9.68149 61.8457 9.61312C61.8863 9.54476 61.9446 9.48848 62.0146 9.45013L66.2068 7.10313C66.5151 6.92999 66.9002 7.14588 66.9002 7.49216V7.85982C66.9002 9.45084 68.6754 10.4462 70.0958 9.64963L74.9355 6.94068C75.2578 6.76465 75.5267 6.50581 75.7139 6.19121C75.9012 5.87661 76 5.51781 76 5.15229C76 4.78677 75.9012 4.42796 75.7139 4.11336C75.5267 3.79876 75.2578 3.53992 74.9355 3.36389V3.36318Z"
            fill="white"
        />
    </svg>
);

export const ICON_NA = () => (
    <svg className="install-icon" xmlns="http://www.w3.org/2000/svg" width="36" height="15" viewBox="0 0 36 15" fill="none">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.37516 13.7693C1.92861 13.7693 1.6993 13.5512 1.6993 13.1926C1.6993 12.5254 2.45361 12.3014 3.82826 12.1573C3.82826 13.0461 3.21878 13.7681 2.37154 13.7681L2.37516 13.7693ZM2.96654 8.76886C1.98413 8.76886 0.854478 9.22518 0.241378 9.7077L0.801375 10.8753C1.29379 10.4309 2.08792 10.0508 2.80481 10.0508C3.48791 10.0508 3.86446 10.276 3.86446 10.7299C3.86446 11.0338 3.61464 11.1886 3.14395 11.2494C1.38189 11.4746 0 11.9547 0 13.2951C0 14.3578 0.766375 15 1.96361 15C2.81809 15 3.57843 14.5318 3.9405 13.9158V14.8332H5.53359V10.9897C5.53359 9.40508 4.41963 8.76529 2.96774 8.76529L2.96654 8.76886ZM18.9578 8.94162V14.8272H20.6632V11.9917C20.6632 10.6442 21.4887 10.2474 22.0644 10.2474C22.3238 10.245 22.5773 10.3189 22.7933 10.4607L23.1059 8.90469C22.8643 8.8093 22.6057 8.76311 22.3456 8.76886C21.4694 8.76886 20.9178 9.15131 20.5545 9.9305V8.94162H18.9578ZM31.005 8.76767C30.1047 8.76767 29.43 9.29428 29.08 9.80064C28.7542 9.14535 28.0662 8.76886 27.2383 8.76886C26.338 8.76886 25.7128 9.26211 25.4256 9.83161V8.94162H23.7806V14.8261H25.4871V11.7963C25.4871 10.7121 26.064 10.1878 26.6023 10.1878C27.0899 10.1878 27.5376 10.4976 27.5376 11.3006V14.8261H29.2405V11.7963C29.2405 10.6954 29.8042 10.1878 30.3666 10.1878C30.8179 10.1878 31.2959 10.5095 31.2959 11.2899V14.8261H33V10.7573C33 9.43487 32.0985 8.76767 31.0086 8.76767M14.8085 8.94162H13.2649V8.34353C13.2649 7.56434 13.7151 7.34273 14.1025 7.34273C14.368 7.34631 14.6275 7.41064 14.8629 7.52979L15.3891 6.34313C15.3891 6.34313 14.8556 6 13.8865 6C12.7979 6 11.5584 6.60643 11.5584 8.50913V8.94162H8.97806V8.34353C8.97806 7.56434 9.42702 7.34273 9.81564 7.34273C10.0812 7.34273 10.3418 7.40707 10.576 7.52979L11.101 6.34313C10.7872 6.16203 10.2839 6 9.59961 6C8.51099 6 7.27151 6.60643 7.27151 8.50913V8.94162H6.28548V10.2391H7.27513V14.8261H8.97685V10.2391H11.562V14.8261H13.2649V10.2391H14.8097V8.94043L14.8085 8.94162Z"
            fill="white"
        />
        <path d="M18 9H16V15H18V9Z" fill="white" />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 7.66934H17.6406C18.5981 4.45624 21.8461 1.63129 25.7071 1.63129C30.4044 1.63129 34.4626 5.44947 34.4626 11.3937C34.4769 12.6139 34.3199 13.8295 33.9969 15H35.5888L35.6054 14.9416C35.8739 13.7822 36.0057 12.5924 35.9998 11.3987C35.9998 4.77082 31.4759 0 25.7106 0C21.182 0 17.1452 3.35645 16.0012 7.67188L16 7.66934Z"
            fill="#4A4AF4"
        />
    </svg>
);

export default function F({ callback }: any) {
    const EU_SITES = ['eu', 'uk', 'de', 'fr', 'it', 'es'];
    const { useLang, useRouter, gtm } = useGlobal();
    const { t } = useLang('RV');
    const { locale, query } = useRouter();
    const moduleFRef = useRef(null);
    const [img, setImg] = useState(['us', 'ca'].includes(locale) ? 2 : 1);
    const [top, setTop] = useState(0);
    const nowTime = query?.timer ? new Date(`${query?.timer} GMT+8`).getTime() : new Date().getTime();
    const LaunchTime_AU = new Date('2024/06/10 10:00:00 GMT+8').getTime();
    const AU_ENTER_LAUNCH_FLAG = nowTime >= LaunchTime_AU;
    const [active, setActive] = useState(EU_SITES.includes(locale) ? t('F_tab0') : ['us', 'ca'].includes(locale) ? t('F_tab2') : t('F_tab1'));
    let tabs = EU_SITES.includes(locale)
        ? [t('F_tab0'), t('F_tab1'), t('F_tab2'), t('F_tab3'), t('F_tab4')]
        : [t('F_tab1'), t('F_tab2'), t('F_tab3'), t('F_tab4')];
    if (['kr', 'us', 'ca'].includes(locale)) {
        tabs = [t('F_tab1'), t('F_tab2'), t('F_tab3')];
    }

    const LOCAL_LAUNCH_TIME: any = {
        us: '',
        ca: '',
        za: '',
        au: '2024/06/10 10:00:00 GMT+8',
        eu: '2024/06/11 15:00:00 GMT+8',
        uk: '2024/06/11 15:00:00 GMT+8',
        de: '2024/06/11 15:00:00 GMT+8',
        fr: '2024/06/11 15:00:00 GMT+8',
        it: '2024/06/11 15:00:00 GMT+8',
        es: '2024/06/11 15:00:00 GMT+8',
    };

    const launchTime = LOCAL_LAUNCH_TIME[locale] ? new Date(LOCAL_LAUNCH_TIME[locale]).getTime() : '';
    const IS_LAUNCH = launchTime ? nowTime >= launchTime : true;

    const [curProducts, setCurProducts] = useState([]);

    const IMG_MAP: any = {
        us: [
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717075949165/6_0.png',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076101427/6_1.png',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076110186/6_2.png',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076120969/6_3.png',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076134399/6_4.png',
        ],
        au: [
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076165184/6_1.png',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076194969/6_2.png',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076205527/6_3.png',
            'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076215786/6_4.png',
        ],
    };

    const PRODUCT_IMGS: any = {
        '220w': 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076546048/6_220w.png',
        '400w': 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076583813/6_400w.png',
        AC: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076618649/6_AC.png',
        delta2_AC: {
            us: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719481896252/6_D2_AC.png',
            au: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077197191/6_delta2_AC.png',
            eu: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077401523/6_delta2_AC.png',
        },
        delta2max_AC: {
            us: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719481896429/6_D2M_AC.png',
            eu: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077428702/6_delta2max_AC.png',
            au: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717470994903/delta2max_AC.png',
        },
        deltapro_AC: {
            us: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1719481896602/6_DP_AC.png',
            eu: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077649382/6_deltapro_AC.png',
            au: 'https://au.ecoflow.com/cdn/shop/files/AU_DP_720x.png?v=1720489656',
        },
        glacier_battery: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076888827/6_Glacier_Battery.png',
        glacier: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076922105/6_Glacier.png',
        lever_wheels: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076958472/6_Lever_Wheels.png',
        LFP: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717076977850/6_LFP.png',
        powerkits: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077004422/6_PowerKits.png',
        wave2: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077029665/6_Wave2.png',
        // AU START
        delta2_AC_220w: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077081695/6_delta2_AC_220w.png',
        delta2_AC_400w: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077137705/6_delta2_AC_400w.png',
        delta2_AC_EB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077168806/6_delta2_AC_delta2EB.png',
        delta2: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077241669/6_delta2.png',
        delta2max_AC_EB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077266245/6_delta2max_AC_delta2maxEB.png',
        deltapro_AC_EB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077305132/6_deltapro_AC_deltaproEB.png',
        glacier_bag: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077353452/6_glacier_bag.png',
        delta2_EB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717468370988/delta2_EB.png',
        cigarette_cable: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717468459697/cigarette_cable.png',
        delta2max: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717469927333/delta2max.png',
        deltapro: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717471113384/deltapro.png',
        delta2max_EB_AU: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717471317249/delta2max_EB_AU.png',
        anderson_mc4: 'https://au.ecoflow.com/cdn/shop/files/20231120-172809_720x.png?v=1700472607',
        // END
        // EU && UK START
        delta2max_EB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077452731/6_delta2max_EB.png',
        deltamax_AC: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077480947/6_deltamax_AC.png',
        deltamax_EB: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077510295/6_deltamax_EB.png',
        deltapro_AC_adapter: {
            eu: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077602602/6_deltapro_AC_adapter.png',
            uk: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077832149/6_deltapro_AC_adapter.png',
        },
        deltapro_EB: {
            eu: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077682225/6_deltapro_EB.png',
            uk: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077900317/6_deltapro_EB.png',
            au: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717471190505/deltapro_EB.png',
        },
        glacier_and_battery: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717122417685/6_glacier_battery.png',
        glacier_deltamax: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077721455/6_glacier_deltamax.png',
        wave2_delta2: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077758516/6_wave2_delta2.png',
        wave2_deltamax: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717077784792/6_wave2_deltamax.png',
        // EU END
    };

    let productsAll: any = [
        [
            {
                tag: ![...EU_SITES, 'au', 'kr'].includes(locale) ? 'F_tab1_card1_tag' : '',
                title: t('F_tab1_card1_title'),
                name: t('F_tab1_card1_name'),
                power: t('F_tab1_card1_power'),
                desc: t('F_tab1_card1_desc'),
                productId: (() => {
                    const map: any = {
                        us: '15302788022345',
                        ca: '15070037180787',
                        eu: '8989474685271',
                        uk: '8896902037843',
                        de: '9242873299279',
                        fr: '9141869379931',
                        it: '9196784058717',
                        es: '9141869314395',
                        au: '7756517146822',
                        kr: '8184730681513',
                        za: '7187057803473',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54348224987209',
                        ca: '52476913025395',
                        eu: '48080021389655',
                        uk: '48154485981523',
                        de: '48824788975951',
                        fr: '48146695455067',
                        it: '50977668137309',
                        es: '48146695225691',
                        au: '42768126181574',
                        kr: '44393356165289',
                        za: '41620506575057',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/ecoflow-500w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/ecoflow-500w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/delta-2-portable-power-station',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2
                        : EU_SITES.includes(locale)
                        ? PRODUCT_IMGS.delta2_AC.eu
                        : PRODUCT_IMGS.delta2_AC.us,
                question: t('F_tab1_card1_sub_question'),
                sub: {
                    id: '220w',
                    name: t('F_tab1_card1_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54348224987209',
                            ca: '52476913025395',
                            eu: '48080021389655',
                            uk: '48154485981523',
                            de: '48824788975951',
                            fr: '48146695455067',
                            it: '50977668137309',
                            es: '48146695225691',
                            au: '42768126181574',
                            za: '41620506575057',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7264162676809',
                            ca: '8292312449178',
                            eu: '10107077493079',
                            uk: '9966309441875',
                            de: '15321895600509',
                            fr: '9976213274971',
                            it: '14940806021496',
                            es: '9976244633947',
                            au: '7876781572294',
                            za: '7204372218065',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41560303272009',
                            ca: '52438137438579',
                            eu: '52180835959127',
                            uk: '52900139499859',
                            de: '56293274190205',
                            fr: '50883301867867',
                            it: '55188408238456',
                            es: '50883390636379',
                            au: '42933622440134',
                            za: '41611167826129',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['220w'],
                },
                comingSoon: comingSoonTime,
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab1_card2_title'),
                name: t('F_tab1_card2_name'),
                power: t('F_tab1_card2_power'),
                desc: t('F_tab1_card2_desc'),
                productId: (() => {
                    const map: any = {
                        us: '15302788022345',
                        ca: '15070037180787',
                        eu: '8364075123031',
                        uk: '8375914889555',
                        de: '8479729123663',
                        fr: '8370479595867',
                        it: '8381299556701',
                        es: '8378588594523',
                        au: '8160446415046',
                        kr: '7737145655465',
                        za: '7451688861905',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54348225019977',
                        ca: '52476913058163',
                        eu: '46496822591831',
                        uk: '46525875290451',
                        de: '48831230968143',
                        fr: '46505490186587',
                        it: '46544737501533',
                        es: '46674132369755',
                        au: '43697138106566',
                        kr: '43039193956521',
                        za: '42191187116241',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC.au
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.wave2_delta2
                        : PRODUCT_IMGS.wave2,
                question: t('F_tab1_card2_sub_question'),
                link_more: `https://${locale}.ecoflow.com/products/wave-2-portable-air-conditioner-delta-2-portable-power-station`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/ecoflow-500w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/ecoflow-500w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/ecoflow-delta-2-800w-alternator-charger',
                    };
                    return map[locale] || '';
                })(),
                sub: {
                    id: 'AC',
                    name: t('F_tab1_card2_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54348225019977',
                            ca: '52476913058163',
                            eu: '46496822591831',
                            uk: '46525875290451',
                            de: '48831230968143',
                            fr: '46505490186587',
                            it: '46544737501533',
                            es: '46674132369755',
                            au: '43697138106566',
                            za: '42191187116241',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '4605523198025',
                            ca: '8066687074458',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7812370235590',
                            za: '7027757940945',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '40573832429641',
                            ca: '52162328330611',
                            eu: '48080282714455',
                            uk: '48154485850451',
                            de: '48824788844879',
                            fr: '48146695323995',
                            it: '50977668006237',
                            es: '48146695094619',
                            au: '42768169697478',
                            za: '41029916000465',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.delta2_EB : PRODUCT_IMGS.AC,
                },
                comingSoon: comingSoonTime,
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab1_card3_title'),
                name: t('F_tab1_card3_name'),
                power: t('F_tab1_card3_power'),
                desc: t('F_tab1_card3_desc'),
                productId: (() => {
                    const map: any = {
                        us: '15302788022345',
                        ca: '15070037180787',
                        eu: '8364025938263',
                        uk: '8480103792979',
                        de: '8376354472271',
                        fr: '8370479890779',
                        it: '8508748661085',
                        es: '8370476974427',
                        au: '8160446415046',
                        kr: '7738246856873',
                        za: '7455007473873',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54348225052745',
                        ca: '52476913090931',
                        eu: '46493270475095',
                        uk: '46877657170259',
                        de: '46538133635407',
                        fr: '46505478783323',
                        it: '48061067657565',
                        es: '46505471115611',
                        au: '43698984091846',
                        kr: '43039330369705',
                        za: '42198877602001',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/ecoflow-500w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/ecoflow-500w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/delta-2-800w-alternator-charger-220w-solar-panel',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_220w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_and_battery
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab1_card3_sub_question'),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab1_card3_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54348225052745',
                            ca: '52476913090931',
                            eu: '46493270475095',
                            uk: '46877657170259',
                            de: '46538133635407',
                            fr: '46505478783323',
                            it: '48061067657565',
                            es: '46505471115611',
                            au: '43698984091846',
                            za: '42198877602001',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '7296662896794',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7883951866054',
                            za: '7027756826833',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                            eu: '48080021389655',
                            uk: '48154485981523',
                            de: '48824788975951',
                            fr: '48146695455067',
                            it: '50977668137309',
                            es: '48146695225691',
                            au: '43939143647430',
                            za: '41820244934865',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.AC
                            : PRODUCT_IMGS.lever_wheels,
                },
                comingSoon: comingSoonTime,
            },
        ],
        [
            {
                tag: ![...EU_SITES, 'au', 'kr'].includes(locale) ? 'F_tab2_card1_tag' : '',
                title: t('F_tab2_card1_title'),
                name: t('F_tab2_card1_name'),
                power: t('F_tab2_card1_power'),
                desc: t('F_tab2_card1_desc'),
                productId: (() => {
                    const map: any = {
                        us: '7049853632585',
                        ca: '8132015980698',
                        eu: '8989474685271',
                        uk: '8896902037843',
                        de: '9242873299279',
                        fr: '9141869379931',
                        it: '9196784058717',
                        es: '9141869314395',
                        au: '7914502422726',
                        kr: '8184728060073',
                        za: '7352407982289',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '41064248934473',
                        ca: '44676925456538',
                        eu: '48080021291351',
                        uk: '48154485883219',
                        de: '48824788877647',
                        fr: '48146695356763',
                        it: '50977668039005',
                        es: '48146695127387',
                        au: '43045698371782',
                        kr: '44393348563113',
                        za: '41935518335185',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/800w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/800w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/delta-2-max-portable-power-station',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2max
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.deltamax_AC
                        : PRODUCT_IMGS.delta2max_AC.us,
                question: t('F_tab2_card1_sub_question'),
                sub: {
                    id: '400w',
                    name: t('F_tab2_card1_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '41064248934473',
                            ca: '44676925456538',
                            eu: '48080021291351',
                            uk: '48154485883219',
                            de: '48824788877647',
                            fr: '48146695356763',
                            it: '50977668039005',
                            es: '48146695127387',
                            au: '43045698371782',
                            za: '41935518335185',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '7296662896794',
                            eu: '10265047433559',
                            uk: '10123990729043',
                            de: '15536875929981',
                            fr: '10084432576859',
                            it: '14963038814584',
                            es: '10084460560731',
                            au: '7876781572294',
                            za: '7425980530897',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                            eu: '51736552538855',
                            uk: '51828861469011',
                            de: '56938043769213',
                            fr: '51330297998683',
                            it: '55270023627128',
                            es: '51300335288667',
                            au: '42933622440134',
                            za: '42122889724113',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['400w'],
                },
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab2_card2_title'),
                name: t('F_tab2_card2_name'),
                power: t('F_tab2_card2_power'),
                desc: t('F_tab2_card2_desc'),
                productId: (() => {
                    const map: any = {
                        us: '7049853632585',
                        ca: '8132015980698',
                        eu: '8369188438359',
                        uk: '8375987962195',
                        de: '8502317187407',
                        fr: '8420087988571',
                        it: '8398855111005',
                        es: '8420093624667',
                        au: '8161146241222',
                        kr: '7777334100137',
                        za: '7451685814481',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '41826189246537',
                        ca: '51645141549427',
                        eu: '46496825803095',
                        uk: '46525988110675',
                        de: '46645526593871',
                        fr: '46726357188955',
                        it: '46668376015197',
                        es: '46726372524379',
                        au: '43698988318918',
                        kr: '43452346957993',
                        za: '42191165849809',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/wave-2-portable-air-conditioner-delta-max-portable-power-station`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/800w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/800w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/ecoflow-delta-2-max-800w-alternator-charger',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2max_AC.au
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.wave2_deltamax
                        : PRODUCT_IMGS.wave2,
                question: t('F_tab2_card2_sub_question'),
                sub: {
                    id: 'AC',
                    name: t('F_tab2_card2_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '41826189246537',
                            ca: '51645141549427',
                            eu: '46496825803095',
                            uk: '46525988110675',
                            de: '46645526593871',
                            fr: '46726357188955',
                            it: '46668376015197',
                            es: '46726372524379',
                            au: '43698988318918',
                            za: '42191165849809',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '7296662896794',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7914513367238',
                            za: '7027757940945',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                            eu: '48080282714455',
                            uk: '48154485850451',
                            de: '48824788844879',
                            fr: '48146695323995',
                            it: '50977668006237',
                            es: '48146695094619',
                            au: '43041593032902',
                            za: '41029916000465',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.delta2max_EB_AU : PRODUCT_IMGS.AC,
                },
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab2_card3_title'),
                name: t('F_tab2_card3_name'),
                power: t('F_tab2_card3_power'),
                desc: t('F_tab2_card3_desc'),
                productId: (() => {
                    const map: any = {
                        us: '7049853632585',
                        ca: '8132015980698',
                        eu: '8369178345815',
                        uk: '8375906402643',
                        de: '8479717654863',
                        fr: '8392939143515',
                        it: '8383198527837',
                        es: '8392991605083',
                        au: '8161146241222',
                        kr: '7777337016489',
                        za: '7455008227537',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '41064248868937',
                        ca: '44676925391002',
                        eu: '46496803684695',
                        uk: '46525853073747',
                        de: '46557798269263',
                        fr: '46689472119131',
                        it: '46558448386397',
                        es: '46689529987419',
                        au: '43699004080326',
                        kr: '43452392571049',
                        za: '42198883729617',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator-delta-max-portable-power-station`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/800w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/800w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/delta-2-max-800w-alternator-charger-220w-solar-panel',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_220w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_deltamax
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab2_card3_sub_question'),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab2_card3_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '41064248868937',
                            ca: '44676925391002',
                            eu: '46496803684695',
                            uk: '46525853073747',
                            de: '46557798269263',
                            fr: '46689472119131',
                            it: '46558448386397',
                            es: '46689529987419',
                            au: '43699004080326',
                            za: '42198883729617',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '7296662896794',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7883951866054',
                            za: '7027756826833',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                            eu: '48080282714455',
                            uk: '48154485850451',
                            de: '48824788844879',
                            fr: '48146695323995',
                            it: '50977668006237',
                            es: '48146695094619',
                            au: '43939143647430',
                            za: '41820244934865',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.AC
                            : PRODUCT_IMGS.lever_wheels,
                },
            },
        ],
        [
            {
                tag: ![...EU_SITES, 'au', 'kr'].includes(locale) ? 'F_tab3_card1_tag' : '',
                title: t('F_tab3_card1_title'),
                name: t('F_tab3_card1_name'),
                power: t('F_tab3_card1_power'),
                desc: t('F_tab3_card1_desc'),
                productId: (() => {
                    const map: any = {
                        us: '7049853632585',
                        ca: '8132015980698',
                        eu: '8989474685271',
                        uk: '8896902037843',
                        de: '9242873299279',
                        fr: '9141869379931',
                        it: '9196784058717',
                        es: '9141869314395',
                        au: '7220911505606',
                        kr: '8194290712745',
                        za: '7027758137553',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '41064248901705',
                        ca: '44676925423770',
                        eu: '48080021356887',
                        uk: '48154485948755',
                        de: '48824788943183',
                        fr: '48146695422299',
                        it: '50977668104541',
                        es: '48146695192923',
                        au: '42736222142662',
                        kr: '44417959657641',
                        za: '41601871610065',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/800w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/800w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/delta-pro-portable-power-station',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.deltapro
                        : locale === 'uk'
                        ? PRODUCT_IMGS.deltapro_AC_adapter.uk
                        : [...EU_SITES, 'kr']?.includes(locale)
                        ? PRODUCT_IMGS.deltapro_AC_adapter.eu
                        : PRODUCT_IMGS.deltapro_AC.us,
                question: t('F_tab3_card1_sub_question'),
                sub: {
                    id: '400w',
                    name: t('F_tab3_card1_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '41064248901705',
                            ca: '44676925423770',
                            eu: '48080021356887',
                            uk: '48154485948755',
                            de: '48824788943183',
                            fr: '48146695422299',
                            it: '50977668104541',
                            es: '48146695192923',
                            au: '42736222142662',
                            za: '41601871610065',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '6618094960713',
                            ca: '7287920001178 ',
                            eu: '10265047433559',
                            uk: '10123990729043',
                            de: '15536875929981',
                            fr: '10084432576859',
                            it: '14963038814584',
                            es: '10084460560731',
                            au: '7876781572294',
                            za: '7027755352273',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '39998021697609',
                            ca: '42092770263194',
                            eu: '51736552538855',
                            uk: '51828861469011',
                            de: '56938043769213',
                            fr: '51330297998683',
                            it: '55270023627128',
                            es: '51300335288667',
                            au: '42933622440134',
                            za: '41601879277777',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['400w'],
                },
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab3_card2_title'),
                name: t('F_tab3_card2_name'),
                power: t('F_tab3_card2_power'),
                desc: t('F_tab3_card2_desc'),
                productId: (() => {
                    const map: any = {
                        us: '7049853632585',
                        ca: '8132015980698',
                        eu: '8368405807447',
                        uk: '8480129319251',
                        de: '8376354537807',
                        fr: '8370477728091',
                        it: '8368685220189',
                        es: '8370477138267',
                        au: '8161150894278',
                        kr: '7777334100137',
                        za: '7453071704273',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '41793261011017',
                        ca: '51632892117363',
                        eu: '46493661921623',
                        uk: '46877691576659',
                        de: '46538134094159',
                        fr: '46505472131419',
                        it: '46532250665309',
                        es: '46505471476059',
                        au: '43939107176646',
                        kr: '43452346957993',
                        za: '42194347589841',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/wave-2-portable-air-conditioner`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/800w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/800w-alternator-charger',
                        za: 'https://za.ecoflow.com/products/delta-pro-800w-alternator-charger',
                    };
                    return map[locale] || '';
                })(),
                img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.deltapro_AC.au : PRODUCT_IMGS.wave2,
                question: t('F_tab3_card2_sub_question'),
                sub: {
                    id: 'AC',
                    name: t('F_tab3_card2_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '41793261011017',
                            ca: '51632892117363',
                            eu: '46493661921623',
                            uk: '46877691576659',
                            de: '46538134094159',
                            fr: '46505472131419',
                            it: '46532250665309',
                            es: '46505471476059',
                            au: '43939107176646',
                            za: '42194347589841',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '6618094960713',
                            ca: '7287920001178',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7220911931590',
                            za: '7027757940945',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '39998021697609',
                            ca: '42092770263194',
                            eu: '48080021356887',
                            uk: '48154485948755',
                            de: '48824788943183',
                            fr: '48146695422299',
                            it: '50977668104541',
                            es: '48146695192923',
                            au: '41687043735750',
                            za: '41029916000465',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.deltapro_EB.au
                            : locale === 'uk'
                            ? PRODUCT_IMGS.deltapro_AC_adapter.uk
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.deltapro_AC_adapter.eu
                            : PRODUCT_IMGS.AC,
                },
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab3_card3_title'),
                name: t('F_tab3_card3_name'),
                power: t('F_tab3_card3_power'),
                desc: t('F_tab3_card3_desc'),
                productId: (() => {
                    const map: any = {
                        us: '6900986675273',
                        ca: '7793994793114',
                        eu: '8364025938263',
                        uk: '8480103792979',
                        de: '8376354472271',
                        fr: '8370479890779',
                        it: '8508748661085',
                        es: '8370476974427',
                        au: '8161150894278',
                        kr: '7777337016489',
                        za: '7470927413457',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '40524279545929',
                        ca: '43515248378010',
                        eu: '46493270475095',
                        uk: '46877657170259',
                        de: '46538133635407',
                        fr: '46505478783323',
                        it: '48061067657565',
                        es: '46505471115611',
                        au: '43699013255366',
                        kr: '43452392571049',
                        za: '42243461939409',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/glacier-portable-refrigerator?variant=40524279545929',
                        za: 'https://za.ecoflow.com/products/ecoflow-delta-pro-800w-alternator-charger-400w-sp',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_400w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_and_battery
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab3_card3_sub_question'),
                hidden: ['us', 'ca'].includes(locale),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab3_card3_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '40524279545929',
                            ca: '43515248378010',
                            eu: '46493270475095',
                            uk: '46877657170259',
                            de: '46538133635407',
                            fr: '46505478783323',
                            it: '48061067657565',
                            es: '46505471115611',
                            au: '43699013255366',
                            za: '42243461939409',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '6903232168009',
                            ca: '7874437349530',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7883951866054',
                            za: '7027757940945',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '40573813620809',
                            ca: '44676938334362',
                            eu: '48080021356887',
                            uk: '48154485948755',
                            de: '48824788943183',
                            fr: '48146695422299',
                            it: '50977668104541',
                            es: '48146695192923',
                            au: '43939143647430',
                            za: '41029916000465',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : locale === 'uk'
                            ? PRODUCT_IMGS.deltapro_AC_adapter.uk
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.deltapro_AC_adapter.eu
                            : PRODUCT_IMGS.lever_wheels,
                },
            },
        ],
        [
            {
                tag: ![...EU_SITES, 'kr', 'us'].includes(locale) ? (locale === 'au' ? 'F_tag_new' : 'F_tab4_card1_tag') : '',
                title: t('F_tab4_card1_title'),
                name: t('F_tab4_card1_name'),
                power: t('F_tab4_card1_power'),
                desc: t('F_tab4_card1_desc'),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_EB
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.deltamax_EB
                        : locale === 'us'
                        ? ''
                        : PRODUCT_IMGS.powerkits,
                link_buy: ['us'].includes(locale) ? '/ecoflow-power-kits/series' : '',
                link_more: EU_SITES.includes(locale)
                    ? `https://${locale}.ecoflow.com/products/delta-max-portable-power-station`
                    : ['us'].includes(locale)
                    ? '/ecoflow-power-kits/series'
                    : '',
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/power-kits-5kva-48v-power-system?variant=41830211682377',
                        za: 'https://za.ecoflow.com/products/ecoflow-delta-2-800w-alternator-charger?variant=42242719908049',
                    };
                    return map[locale] || '';
                })(),
                buyNowDisableTime: (() => {
                    const map: any = {
                        us: '2024/12/10 16:00:00 GMT+8',
                    };
                    return map[locale] || '';
                })(),
                question: [...EU_SITES, 'au'].includes(locale) ? t('F_tab4_card2_sub_question') : '',
                productId: (() => {
                    const map: any = {
                        us: '7352587878473',
                        ca: '7368071905434',
                        eu: '6939282112676',
                        uk: '7185784537280',
                        de: '7530382065911',
                        fr: '7607013048546',
                        it: '7709724901617',
                        es: '7693952876766',
                        au: '8160446415046',
                        kr: '',
                        za: '7451688861905',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '41830211747913',
                        ca: '42092724945050',
                        eu: '46842062176599',
                        uk: '42044415049920',
                        de: '46836864975183',
                        fr: '46853506335067',
                        it: '42925566099697',
                        es: '42969733300446',
                        au: '43697138139334',
                        kr: '',
                        za: '42242719908049',
                    };
                    return map[locale] || '';
                })(),
                discountPrice: undefined,
                originalPrice: undefined,
                sub: [...EU_SITES, 'au', 'za', 'us']?.includes(locale)
                    ? {
                          id: 'level_wheels',
                          name: t('F_tab4_card1_sub1_name'),
                          parentVariantId: (() => {
                              const map: any = {
                                  us: '41830211747913',
                                  eu: '46842062176599',
                                  uk: '42044415049920',
                                  de: '46836864975183',
                                  fr: '46853506335067',
                                  it: '42925566099697',
                                  es: '42969733300446',
                                  au: '43697138139334',
                                  za: '42242719908049',
                              };
                              return map[locale] || '';
                          })(),
                          productId: (() => {
                              const map: any = {
                                  us: '7352583651401',
                                  eu: '8989474685271',
                                  uk: '8896902037843',
                                  de: '9242873299279',
                                  fr: '9141869379931',
                                  it: '9196784058717',
                                  es: '9141869314395',
                                  au: '7876781572294',
                                  za: '7027757940945',
                              };
                              return map[locale] || '';
                          })(),
                          variantId: (() => {
                              const map: any = {
                                  us: '41830186745929',
                                  eu: '48080282714455',
                                  uk: '48154485850451',
                                  de: '48824788844879',
                                  fr: '48146695323995',
                                  it: '50977668006237',
                                  es: '48146695094619',
                                  au: '42933622440134',
                                  za: '41029916000465',
                              };
                              return map[locale] || '';
                          })(),
                          img: ['za', 'us'].includes(locale)
                              ? ''
                              : locale === 'au'
                              ? PRODUCT_IMGS.cigarette_cable
                              : EU_SITES?.includes(locale)
                              ? PRODUCT_IMGS.AC
                              : PRODUCT_IMGS.lever_wheels,
                      }
                    : undefined,
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab4_card2_title'),
                name: t('F_tab4_card2_name'),
                power: t('F_tab4_card2_power'),
                desc: t('F_tab4_card2_desc'),
                productId: (() => {
                    const map: any = {
                        us: '7064125210697',
                        ca: '8130581463194',
                        eu: '8414996627799',
                        uk: '8422703366483',
                        de: '8513034813775',
                        fr: '8431233794395',
                        it: '8415773524317',
                        es: '8435033899355',
                        au: '8161146241222',
                        kr: '7777334100137',
                        za: '7451685814481',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '41106590892105',
                        ca: '44674797240474',
                        eu: '46790633947479',
                        uk: '46663778140499',
                        de: '46739708576079',
                        fr: '46793766994267',
                        it: '46795180441949',
                        es: '46787970302299',
                        au: '43699004113094',
                        kr: '43452346957993',
                        za: '42242722300113',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/delta-2-max-portable-power-station`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/wave-2-portable-air-conditioner',
                        za: 'https://za.ecoflow.com/products/ecoflow-delta-2-max-800w-alternator-charger?variant=42242722300113',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2max_AC_EB
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.delta2max_EB
                        : PRODUCT_IMGS.wave2,
                question: t('F_tab4_card2_sub_question'),
                sub: {
                    id: 'AC',
                    name: t('F_tab4_card2_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '41106590892105',
                            ca: '44674797240474',
                            eu: '46790633947479',
                            uk: '46663778140499',
                            de: '46739708576079',
                            fr: '46793766994267',
                            it: '46795180441949',
                            es: '46787970302299',
                            au: '43699004113094',
                            za: '42242722300113',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7049853632585',
                            ca: '8132015980698',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7876781572294',
                            za: '7027757940945',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41064248836169',
                            ca: '44676925358234',
                            eu: '48080282714455',
                            uk: '48154485850451',
                            de: '48824788844879',
                            fr: '48146695323995',
                            it: '50977668006237',
                            es: '48146695094619',
                            au: '42933622440134',
                            za: '41029916000465',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS.AC,
                },
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab4_card3_title'),
                name: t('F_tab4_card3_name'),
                power: t('F_tab4_card3_power'),
                desc: t('F_tab4_card3_desc'),
                productId: (() => {
                    const map: any = {
                        us: '6900986675273',
                        ca: '7793994793114',
                        eu: '6939282047140',
                        uk: '7309292437696',
                        de: '7530381967607',
                        fr: '7607012983010',
                        it: '7741715677425',
                        es: '7718839714014',
                        au: '8161150894278',
                        kr: '7777337016489',
                        za: '7453071704273',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '40524279545929',
                        ca: '43515248378010',
                        eu: '46842063356247',
                        uk: '42975233147072',
                        de: '46836884734287',
                        fr: '46853508628827',
                        it: '43017126772977',
                        es: '43080945172702',
                        au: '43699013288134',
                        kr: '43452392571049',
                        za: '42242722857169',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/delta-pro-portable-power-station`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/glacier-portable-refrigerator?variant=40524279545929',
                        za: 'https://za.ecoflow.com/products/delta-pro-800w-alternator-charger?variant=42242722857169',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.deltapro_AC_EB
                        : locale === 'uk'
                        ? PRODUCT_IMGS.deltapro_EB.uk
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.deltapro_EB.eu
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab4_card3_sub_question'),
                sub: {
                    id: 'AC',
                    name: t('F_tab4_card3_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '40524279545929',
                            ca: '43515248378010',
                            eu: '46842063356247',
                            uk: '42975233147072',
                            de: '46836884734287',
                            fr: '46853508628827',
                            it: '43017126772977',
                            es: '43080945172702',
                            au: '43699013288134',
                            za: '42242722857169',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '6903232168009',
                            ca: '7874437349530',
                            eu: '8989474685271',
                            uk: '8896902037843',
                            de: '9242873299279',
                            fr: '9141869379931',
                            it: '9196784058717',
                            es: '9141869314395',
                            au: '7876781572294',
                            za: '7027757940945',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '40573813620809',
                            ca: '44676938334362',
                            eu: '48080282714455',
                            uk: '48154485850451',
                            de: '48824788844879',
                            fr: '48146695323995',
                            it: '50977668006237',
                            es: '48146695094619',
                            au: '42933622440134',
                            za: '41029916000465',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.cigarette_cable
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.AC
                            : PRODUCT_IMGS.lever_wheels,
                },
            },
        ],
    ];

    /**
     * US、CA新产品
     */
    const produtsAllNew = [
        [
            {
                tag: '',
                title: t('F_tab1_card4_title_new'),
                name: t('F_tab1_card4_name_new'),
                power: t('F_tab1_card4_power_new'),
                desc: t('F_tab1_card4_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '15386067730505',
                        ca: '15164532916595',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54692156833865',
                        ca: '62060639682931',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-classic-portable-power-station?variant=54692156833865',
                        ca: 'https://ca.ecoflow.com/products/delta-3-classic-portable-power-station?variant=62060639682931',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2
                        : EU_SITES.includes(locale)
                        ? PRODUCT_IMGS.delta2_AC.eu
                        : PRODUCT_IMGS.delta2_AC.us,
                question: t('F_tab1_card4_sub_question_new'),
                sub: {
                    id: '220w',
                    name: t('F_tab1_card4_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54692156833865',
                            ca: '62060639584627',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '8292312449178',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['220w'],
                },
                comingSoon: comingSoonTime,
            },
            // {
            //     tag: ![...EU_SITES, 'au', 'kr'].includes(locale) ? 'F_tab1_card1_tag' : '',
            //     title: t('F_tab1_card1_title_new'),
            //     name: t('F_tab1_card1_name_new'),
            //     power: t('F_tab1_card1_power_new'),
            //     desc: t('F_tab1_card1_desc_new'),
            //     productId: (() => {
            //         const map: any = {
            //             us: '15302788022345',
            //             ca: '15070037180787',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     variantId: (() => {
            //         const map: any = {
            //             us: '54348224987209',
            //             ca: '52476913025395',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
            //     learn_more: (() => {
            //         const map: any = {
            //             us: 'https://us.ecoflow.com/products/ecoflow-500w-alternator-charger',
            //             ca: 'https://ca.ecoflow.com/products/ecoflow-500w-alternator-charger',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     img:
            //         locale === 'za'
            //             ? ''
            //             : locale === 'au'
            //             ? PRODUCT_IMGS.delta2
            //             : EU_SITES.includes(locale)
            //             ? PRODUCT_IMGS.delta2_AC.eu
            //             : PRODUCT_IMGS.delta2_AC.us,
            //     question: t('F_tab1_card1_sub_question'),
            //     sub: {
            //         id: '220w',
            //         name: t('F_tab1_card1_sub1_name_new'),
            //         parentVariantId: (() => {
            //             const map: any = {
            //                 us: '54348224987209',
            //                 ca: '52476913025395',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         productId: (() => {
            //             const map: any = {
            //                 us: '7264162676809',
            //                 ca: '8292312449178',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         variantId: (() => {
            //             const map: any = {
            //                 us: '41731341353033',
            //                 ca: '52438137438579',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['220w'],
            //     },
            //     comingSoon: comingSoonTime,
            // },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab1_card2_title_new'),
                name: t('F_tab1_card2_name_new'),
                power: t('F_tab1_card2_power_new'),
                desc: t('F_tab1_card2_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '15302788022345',
                        ca: '15070037180787',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54348225019977',
                        ca: '52476913058163',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC.au
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.wave2_delta2
                        : PRODUCT_IMGS.wave2,
                question: t('F_tab1_card2_sub_question'),
                link_more: `https://${locale}.ecoflow.com/products/wave-2-portable-air-conditioner-delta-2-portable-power-station`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/ecoflow-500w-alternator-charger',
                        ca: 'https://ca.ecoflow.com/products/ecoflow-500w-alternator-charger',
                    };
                    return map[locale] || '';
                })(),
                sub: {
                    id: 'AC',
                    name: t('F_tab1_card2_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54348225019977',
                            ca: '52476913058163',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7264162676809',
                            ca: '8292312449178',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41731341353033',
                            ca: '52438137438579',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.delta2_EB : PRODUCT_IMGS.AC,
                },
                comingSoon: comingSoonTime,
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab1_card3_title_new'),
                name: t('F_tab1_card3_name_new'),
                power: t('F_tab1_card3_power_new'),
                desc: t('F_tab1_card3_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '15302788022345',
                        ca: '15070037180787',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '55334230786121',
                        ca: '52476913090931',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/ecoflow-500w-alternator-charger?variant=55334230786121',
                        ca: 'https://ca.ecoflow.com/products/ecoflow-500w-alternator-charger',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_220w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_and_battery
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab1_card3_sub_question'),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab1_card3_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54348225052745',
                            ca: '52476913090931',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '7296662896794',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.AC
                            : PRODUCT_IMGS.lever_wheels,
                },
                comingSoon: comingSoonTime,
            },
        ],
        [
            {
                tag: '',
                title: t('F_tab2_card4_title_new'),
                name: t('F_tab2_card4_name_new'),
                power: t('F_tab2_card4_power_new'),
                desc: t('F_tab2_card4_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '15386147061833',
                        ca: '15164532654451',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54718700027977',
                        ca: '62106661683571',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=54718700027977',
                        ca: 'https://ca.ecoflow.com/products/delta-3-max-series-portable-power-station?variant=62106661683571',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2max
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.deltamax_AC
                        : PRODUCT_IMGS.delta2max_AC.us,
                question: t('F_tab2_card4_sub_question_new'),
                sub: {
                    id: '220w',
                    name: t('F_tab2_card4_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54718700027977',
                            ca: '62106661683571',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '7296662896794',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['400w'],
                },
            },
            {
                tag: '',
                title: t('F_tab2_card1_title_new'),
                name: t('F_tab2_card1_name_new'),
                power: t('F_tab2_card1_power_new'),
                desc: t('F_tab2_card1_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '6905537888329',
                        ca: '7825964400794',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54308488839241',
                        ca: '52451628417395',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/delta-2-max-portable-power-station?_pos=3&_sid=ca7d92a45&_ss=r&variant=54308488839241',
                        ca: 'https://ca.ecoflow.com/products/delta-2-max-portable-power-station?variant=52451628417395',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2max
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.deltamax_AC
                        : PRODUCT_IMGS.delta2max_AC.us,
                question: t('F_tab2_card1_sub_question_new'),
                sub: {
                    id: '220w',
                    name: t('F_tab2_card1_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54308488839241',
                            ca: '52451628417395',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7003545108553',
                            ca: '7296662896794',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41670394576969',
                            ca: '43874721824922',
                        };
                        return map[locale] || '';
                    })(),
                    img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['400w'],
                },
            },
            // {
            //     tag: locale === 'au' ? 'F_tag_new' : '',
            //     title: t('F_tab2_card2_title_new'),
            //     name: t('F_tab2_card2_name_new'),
            //     power: t('F_tab2_card2_power_new'),
            //     desc: t('F_tab2_card2_desc_new'),
            //     productId: (() => {
            //         const map: any = {
            //             us: '7414780887113',
            //             ca: '15052470288755',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     variantId: (() => {
            //         const map: any = {
            //             us: '54590690623561',
            //             ca: '52405166506355',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     link_more: `https://${locale}.ecoflow.com/products/wave-2-portable-air-conditioner-delta-max-portable-power-station`,
            //     learn_more: (() => {
            //         const map: any = {
            //             us: 'https://us.ecoflow.com/products/ecoflow-glacier-classic-portable-fridge-freezer',
            //             ca: 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-portable-fridge-freezer?variant=52405166506355',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     img:
            //         locale === 'za'
            //             ? ''
            //             : locale === 'au'
            //             ? PRODUCT_IMGS.delta2max_AC.au
            //             : EU_SITES?.includes(locale)
            //             ? PRODUCT_IMGS.wave2_deltamax
            //             : PRODUCT_IMGS.wave2,
            //     question: t('F_tab2_card2_sub_question_new'),
            //     sub: {
            //         id: 'AC',
            //         name: t('F_tab2_card2_sub1_name_new'),
            //         parentVariantId: (() => {
            //             const map: any = {
            //                 us: '54590690623561',
            //                 ca: '52405166506355',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         productId: (() => {
            //             const map: any = {
            //                 us: '15302788022345',
            //                 ca: '15070037180787',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         variantId: (() => {
            //             const map: any = {
            //                 us: '54348224954441',
            //                 ca: '52476912992627',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.delta2max_EB_AU : PRODUCT_IMGS.AC,
            //     },
            // },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab2_card3_title_new'),
                name: t('F_tab2_card3_name_new'),
                power: t('F_tab2_card3_power_new'),
                desc: t('F_tab2_card3_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '7414779576393',
                        ca: '15052470157683',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54335533842505',
                        ca: '52405151564147',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator-delta-max-portable-power-station`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                        ca: 'https://ca.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_220w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_deltamax
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab2_card3_sub_question_new'),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab2_card3_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54335533842505',
                            ca: '52405151564147',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '15302788022345',
                            ca: '15070037180787',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '54348224954441',
                            ca: '52476912992627',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.AC
                            : PRODUCT_IMGS.lever_wheels,
                },
            },
        ],
        [
            // {
            //     tag: ![...EU_SITES, 'au', 'kr'].includes(locale) ? 'F_tab3_card1_tag' : '',
            //     title: t('F_tab3_card1_title_new'),
            //     name: t('F_tab3_card1_name_new'),
            //     power: t('F_tab3_card1_power_new'),
            //     desc: t('F_tab3_card1_desc_new'),
            //     productId: (() => {
            //         const map: any = {
            //             us: '7049853632585',
            //             ca: '8132015980698',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     variantId: (() => {
            //         const map: any = {
            //             us: '41064248901705',
            //             ca: '44676925423770',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
            //     learn_more: (() => {
            //         const map: any = {
            //             us: 'https://us.ecoflow.com/products/800w-alternator-charger?variant=41064248901705',
            //             ca: 'https://ca.ecoflow.com/products/800w-alternator-charger?variant=44676925423770',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     img:
            //         locale === 'za'
            //             ? ''
            //             : locale === 'au'
            //             ? PRODUCT_IMGS.deltapro
            //             : locale === 'uk'
            //             ? PRODUCT_IMGS.deltapro_AC_adapter.uk
            //             : [...EU_SITES, 'kr']?.includes(locale)
            //             ? PRODUCT_IMGS.deltapro_AC_adapter.eu
            //             : PRODUCT_IMGS.deltapro_AC.us,
            //     question: t('F_tab3_card1_sub_question_new'),
            //     sub: {
            //         id: '400w',
            //         name: t('F_tab3_card1_sub1_name_new'),
            //         parentVariantId: (() => {
            //             const map: any = {
            //                 us: '41064248901705',
            //                 ca: '44676925423770',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         productId: (() => {
            //             const map: any = {
            //                 us: '6618094960713',
            //                 ca: '7287920001178 ',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         variantId: (() => {
            //             const map: any = {
            //                 us: '39998021697609',
            //                 ca: '42092770263194',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.cigarette_cable : PRODUCT_IMGS['400w'],
            //     },
            // },
            // {
            //     tag: locale === 'au' ? 'F_tag_new' : '',
            //     title: t('F_tab3_card2_title_new'),
            //     name: t('F_tab3_card2_name_new'),
            //     power: t('F_tab3_card2_power_new'),
            //     desc: t('F_tab3_card2_desc_new'),
            //     productId: (() => {
            //         const map: any = {
            //             us: '7414780887113',
            //             ca: '15052470288755',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     variantId: (() => {
            //         const map: any = {
            //             us: '42093676462153',
            //             ca: '52405166375283',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     link_more: `https://${locale}.ecoflow.com/products/wave-2-portable-air-conditioner`,
            //     learn_more: (() => {
            //         const map: any = {
            //             us: 'https://us.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-fridge-freezer',
            //             ca: 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-fridge-freezer',
            //         };
            //         return map[locale] || '';
            //     })(),
            //     img: locale === 'za' ? '' : locale === 'au' ? PRODUCT_IMGS.deltapro_AC.au : PRODUCT_IMGS.wave2,
            //     question: t('F_tab3_card2_sub_question_new'),
            //     sub: {
            //         id: 'AC',
            //         name: t('F_tab3_card2_sub1_name_new'),
            //         parentVariantId: (() => {
            //             const map: any = {
            //                 us: '42093676462153',
            //                 ca: '52405166375283',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         productId: (() => {
            //             const map: any = {
            //                 us: '15302788022345',
            //                 ca: '15070037180787',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         variantId: (() => {
            //             const map: any = {
            //                 us: '54348224954441',
            //                 ca: '52476912992627',
            //             };
            //             return map[locale] || '';
            //         })(),
            //         img:
            //             locale === 'za'
            //                 ? ''
            //                 : locale === 'au'
            //                 ? PRODUCT_IMGS.deltapro_EB.au
            //                 : locale === 'uk'
            //                 ? PRODUCT_IMGS.deltapro_AC_adapter.uk
            //                 : EU_SITES?.includes(locale)
            //                 ? PRODUCT_IMGS.deltapro_AC_adapter.eu
            //                 : PRODUCT_IMGS.AC,
            //     },
            // },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab3_card4_title_new'),
                name: t('F_tab3_card4_name_new'),
                power: t('F_tab3_card4_power_new'),
                desc: t('F_tab3_card4_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '15386143096905',
                        ca: '15164531016051',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54718705041481',
                        ca: '62106740556147',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54718705041481',
                        ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62106740556147',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_400w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_and_battery
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab3_card4_sub_question_new'),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab3_card4_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54718705041481',
                            ca: '62106740556147',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '7049853632585',
                            ca: '8132015980698',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '41064248868937',
                            ca: '44676925358234',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : locale === 'uk'
                            ? PRODUCT_IMGS.deltapro_AC_adapter.uk
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.deltapro_AC_adapter.eu
                            : PRODUCT_IMGS.lever_wheels,
                },
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab3_card5_title_new'),
                name: t('F_tab3_card5_name_new'),
                power: t('F_tab3_card5_power_new'),
                desc: t('F_tab3_card5_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '15386143096905',
                        ca: '15164531016051',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54692157784137',
                        ca: '62060629655923',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=54692157784137',
                        ca: 'https://ca.ecoflow.com/products/delta-3-ultra-series-portable-power-station?variant=62060629655923',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_400w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_and_battery
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab3_card5_sub_question_new'),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab3_card5_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54692157784137',
                            ca: '62060629655923',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '15302788022345',
                            ca: '15070037180787',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '54348224954441',
                            ca: '52476912992627',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : locale === 'uk'
                            ? PRODUCT_IMGS.deltapro_AC_adapter.uk
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.deltapro_AC_adapter.eu
                            : PRODUCT_IMGS.lever_wheels,
                },
            },
            {
                tag: locale === 'au' ? 'F_tag_new' : '',
                title: t('F_tab3_card3_title_new'),
                name: t('F_tab3_card3_name_new'),
                power: t('F_tab3_card3_power_new'),
                desc: t('F_tab3_card3_desc_new'),
                productId: (() => {
                    const map: any = {
                        us: '7414779576393',
                        ca: '15052470157683',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        us: '54335533842505',
                        ca: '52405151564147',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/glacier-portable-refrigerator`,
                learn_more: (() => {
                    const map: any = {
                        us: 'https://us.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                        ca: 'https://ca.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                    };
                    return map[locale] || '';
                })(),
                img:
                    locale === 'za'
                        ? ''
                        : locale === 'au'
                        ? PRODUCT_IMGS.delta2_AC_400w
                        : EU_SITES?.includes(locale)
                        ? PRODUCT_IMGS.glacier_and_battery
                        : PRODUCT_IMGS.glacier,
                question: t('F_tab3_card3_sub_question_new'),
                sub: {
                    id: 'level_wheels',
                    name: t('F_tab3_card3_sub1_name_new'),
                    parentVariantId: (() => {
                        const map: any = {
                            us: '54335533842505',
                            ca: '52405151564147',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            us: '15302788022345',
                            ca: '15070037180787',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            us: '54348224954441',
                            ca: '52476912992627',
                        };
                        return map[locale] || '';
                    })(),
                    img:
                        locale === 'za'
                            ? ''
                            : locale === 'au'
                            ? PRODUCT_IMGS.anderson_mc4
                            : locale === 'us'
                            ? PRODUCT_IMGS.glacier_battery
                            : locale === 'uk'
                            ? PRODUCT_IMGS.deltapro_AC_adapter.uk
                            : EU_SITES?.includes(locale)
                            ? PRODUCT_IMGS.deltapro_AC_adapter.eu
                            : PRODUCT_IMGS.lever_wheels,
                },
            },
        ],
    ];

    if (EU_SITES.includes(locale)) {
        productsAll.unshift([
            {
                title: t('F_tab0_card1_title'),
                name: t('F_tab0_card1_name'),
                power: t('F_tab0_card1_power'),
                desc: t('F_tab0_card1_desc'),
                productId: (() => {
                    const map: any = {
                        eu: '8989474685271',
                        uk: '8896902037843',
                        de: '9242873299279',
                        fr: '9141869379931',
                        it: '9196784058717',
                        es: '9141869314395',
                        za: '',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        eu: '48080021291351',
                        uk: '48154485883219',
                        de: '48824788877647',
                        fr: '48146695356763',
                        it: '50977668039005',
                        es: '48146695127387',
                        za: '',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                img: PRODUCT_IMGS.deltamax_AC,
                question: t('F_tab0_card1_sub_question'),
                sub: {
                    id: '220w',
                    name: t('F_tab0_card1_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            eu: '48080021291351',
                            uk: '48154485883219',
                            de: '48824788877647',
                            fr: '48146695356763',
                            it: '50977668039005',
                            es: '48146695127387',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            eu: '10265047433559',
                            uk: '10123990729043',
                            de: '15536875929981',
                            fr: '10084432576859',
                            it: '14963038814584',
                            es: '10084460560731',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            eu: '51736552538855',
                            uk: '51828861469011',
                            de: '56938043769213',
                            fr: '51330297998683',
                            it: '55270023627128',
                            es: '51300335288667',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    img: PRODUCT_IMGS['400w'],
                },
            },
            {
                title: t('F_tab0_card2_title'),
                name: t('F_tab0_card2_name'),
                power: t('F_tab0_card2_power'),
                desc: t('F_tab0_card2_desc'),
                productId: (() => {
                    const map: any = {
                        eu: '8989474685271',
                        uk: '8896902037843',
                        de: '9242873299279',
                        fr: '9141869379931',
                        it: '9196784058717',
                        es: '9141869314395',
                        za: '',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        eu: '48080021422423',
                        uk: '48154486014291',
                        de: '48824789008719',
                        fr: '48146695487835',
                        it: '50977668170077',
                        es: '48146695258459',
                        za: '',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                img: PRODUCT_IMGS.deltamax_AC,
                question: t('F_tab0_card2_sub_question'),
                sub: {
                    id: 'AC',
                    name: t('F_tab0_card2_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            eu: '48080021422423',
                            uk: '48154486014291',
                            de: '48824789008719',
                            fr: '48146695487835',
                            it: '50977668170077',
                            es: '48146695258459',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            eu: '10265047433559',
                            uk: '10123990729043',
                            de: '15536875929981',
                            fr: '10084432576859',
                            it: '14963038814584',
                            es: '10084460560731',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            eu: '51736552538855',
                            uk: '51828861469011',
                            de: '56938043769213',
                            fr: '51330297998683',
                            it: '55270023627128',
                            es: '51300335288667',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    img: PRODUCT_IMGS['400w'],
                },
            },
            {
                title: t('F_tab0_card3_title'),
                name: t('F_tab0_card3_name'),
                power: t('F_tab0_card3_power'),
                desc: t('F_tab0_card3_desc'),
                productId: (() => {
                    const map: any = {
                        eu: '8989474685271',
                        uk: '8896902037843',
                        de: '9242873299279',
                        fr: '9141869379931',
                        it: '9196784058717',
                        es: '9141869314395',
                        za: '',
                    };
                    return map[locale] || '';
                })(),
                variantId: (() => {
                    const map: any = {
                        eu: '48080021356887',
                        uk: '48154485948755',
                        de: '48824788943183',
                        fr: '48146695422299',
                        it: '50977668104541',
                        es: '48146695192923',
                        za: '',
                    };
                    return map[locale] || '';
                })(),
                link_more: `https://${locale}.ecoflow.com/products/800w-alternator-charger`,
                img: PRODUCT_IMGS.deltapro_AC_adapter[locale] || PRODUCT_IMGS.deltapro_AC_adapter.eu,
                question: t('F_tab0_card3_sub_question'),
                sub: {
                    id: 'AC',
                    name: t('F_tab0_card3_sub1_name'),
                    parentVariantId: (() => {
                        const map: any = {
                            eu: '48080021356887',
                            uk: '48154485948755',
                            de: '48824788943183',
                            fr: '48146695422299',
                            it: '50977668104541',
                            es: '48146695192923',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    productId: (() => {
                        const map: any = {
                            eu: '10265047433559',
                            uk: '10123990729043',
                            de: '15536875929981',
                            fr: '10084432576859',
                            it: '14963038814584',
                            es: '10084460560731',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    variantId: (() => {
                        const map: any = {
                            eu: '51736552538855',
                            uk: '51828861469011',
                            de: '56938043769213',
                            fr: '51330297998683',
                            it: '55270023627128',
                            es: '51300335288667',
                            za: '',
                        };
                        return map[locale] || '';
                    })(),
                    img: PRODUCT_IMGS['400w'],
                },
            },
        ]);
    }

    if (locale === 'kr') {
        productsAll[3].shift();
    }

    const getComingSoonState = (comingSoon?: string) => {
        /**由于query.timer参数有延迟，所以用window.location.search */
        if (typeof window === 'undefined') return false;
        const queryParams = new URLSearchParams(window.location.search);
        const timer = queryParams.get('timer'); // 'John'
        const nowTime = timer ? new Date(`${timer} GMT+8`).getTime() : new Date().getTime();
        if (comingSoon && ['us', 'ca'].includes(locale)) {
            const endTime = new Date(comingSoon).getTime();
            return nowTime < endTime;
        }
        return false;
    };

    if (['us', 'ca'].includes(locale) && !getComingSoonState(comingSoonTime)) {
        productsAll = [...produtsAllNew];
    }

    const getBuyNowPreOrder = (product: any) => {
        const buyNowDisableTime = curProducts.find((i: any) => i?.variantId === product?.variantId)?.buyNowDisableTime ?? '2000/01/01 15:00:00 GMT+8';
        let now = new Date();
        if (query._timer) {
            now = new Date(query._timer as string);
        }
        const buyNowTime = new Date(buyNowDisableTime);
        if (now < buyNowTime) return true; // 时间还没到，不能购买
        return false;
    };

    const [requestedArr, setRequestedArr] = useState(new Array(productsAll?.length).fill(null));

    const handleClickTab = (tab: string, k: number) => {
        setActive(tab);
        setImg(k + 1);
        const info = document.querySelector('.RV-F .info-box') as HTMLDivElement;
        info.scrollIntoView({ behavior: 'smooth', block: 'start' });
        const tabBox = document.querySelector('.RV-F .tabs-box') as HTMLDivElement;
        const { scrollWidth, clientWidth } = tabBox;
        if (scrollWidth > window?.innerWidth) {
            if (window.innerWidth >= 768) {
                if (k >= tabs?.length / 2) {
                    tabBox.scrollLeft = scrollWidth - clientWidth;
                } else {
                    tabBox.scrollLeft = 0;
                }
            }
            if (window?.innerWidth < 768) {
                const tab = tabBox?.querySelector('.tab') as HTMLUListElement;
                tabBox.scrollLeft = tab?.offsetWidth * k + (k + 1 >= tabs?.length ? 0 : 12);
            }
        }
    };

    const handleBuy = (product: any) => {
        if (EU_SITES?.includes(locale) && !IS_LAUNCH) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'select_product',
                list_name: t('F_title'),
                product_name: product.name,
                button_name: t('F_more'),
            });
            const linkMore = product?.link_more?.startsWith('http')
                ? `${product?.link_more + (String(product?.link_more)?.indexOf('?') !== -1 ? '&' : '?')}utm_source=scenario+page&utm_medium=Pillar`
                : `${window.origin}/${locale}${product?.link_buy}`;
            window.open(linkMore, '_blank');
        } else {
            if (locale === 'za') {
                // 跳转结算页
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'checkout',
                    button_name: product.name,
                });
            } else {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'buy',
                    product_name: product.name,
                    position: t('F_buy'),
                });
            }
            if (!product?.link_buy) {
                let frag = `https://${locale}.ecoflow.com/cart/${product.variantId}:1`;
                if (product?.sub && product?.sub?.quantity > 0) {
                    frag += `,${product?.sub?.variantId}:${product?.sub?.quantity}`;
                }
                frag += '?channel=buy_button';
                window.open(frag, '_blank');
            } else {
                if (product?.inventory > 0) {
                    window.open(`${window.origin}/${locale}${product?.link_buy}`, '_blank');
                }
            }
        }
    };

    const handlerLearnMore = (product: any) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'buy',
            product_name: product.name,
            position: `Learn More ${product.name}`,
        });
        window.open(product.learn_more, '_blank');
    };

    const handleCalculate = (data: any, n: number) => {
        const tempBundles = JSON.parse(JSON.stringify(curProducts));
        const parentIdx = tempBundles?.findIndex((bundle: any) => bundle?.variantId === data?.parentVariantId);
        tempBundles[parentIdx].sub.quantity = n;
        setCurProducts(tempBundles);
    };

    const getAsynItem = async (item: any) => {
        const { productId, variantId } = item;
        if (productId && variantId) {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res.data && typeof res.data === 'object' && Object.keys(res.data).length === 0) {
                            return resolve(null);
                        }

                        item.discountPrice = res?.data?.price;
                        item.originalPrice = res?.data?.compareAtPrice || res?.data?.price;
                        item.inventory = res?.data?.inventoryQuantity ?? undefined;
                        item.inventoryPolicy = res?.data?.inventoryPolicy ?? 'continue';
                        if (!item?.img && res?.data?.img) {
                            item.img = res?.data?.img;
                        }

                        /**对于US和CA站点的图片单独处理 */
                        if (['us', 'ca'].includes(locale) && res.data?.variantImg) {
                            item.img = res?.data?.variantImg;
                        }

                        // item.inventory = 100;
                        if (item.id) {
                            item.quantity = 0;
                        }
                        if (item?.sub) {
                            await getAsynItem(item?.sub);
                        }
                        return resolve(res);
                    } else {
                        console.error(res?.message);
                        return reject(res?.message);
                    }
                } catch (e) {
                    console.error(e);
                    return reject(e);
                }
            });
        }
        return;
    };

    useEffect(() => {
        if (img > 0) {
            if (!requestedArr[img - 1]) {
                const groupProducts = JSON.parse(JSON.stringify(productsAll[img - 1]));
                const promises = groupProducts?.map((item: any) => getAsynItem(item));
                Promise.all(promises)
                    .then((res) => {
                        const result = groupProducts.filter((_: any, i: number) => res[i] !== null);
                        console.log(result, res, 'result====');
                        setCurProducts(result);
                        const newArr = JSON.parse(JSON.stringify(requestedArr));
                        newArr[img - 1] = JSON.parse(JSON.stringify(result));
                        setRequestedArr(newArr);
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            } else {
                setCurProducts(requestedArr[img - 1]);
            }
        }
    }, [img]);

    useEffect(() => {
        let h = 0;
        const bar = document.querySelector('.announcement-bar') as HTMLElement;
        if (bar) {
            const styles = window.getComputedStyle(bar);
            const position = styles.position;
            if (bar && position === 'sticky') {
                h += bar?.offsetHeight;
            }
        }
        const tab = document.querySelector('.RV-Tab') as HTMLElement;
        if (tab) {
            const styles = window.getComputedStyle(tab);
            const position = styles.position;
            if (tab && position === 'sticky') {
                h += tab?.offsetHeight;
            }
        }
        setTop(h);
    }, []);

    const AddReduceCalc = ({ data, callback }: any) => {
        const NUM_MIN = data?.min || 0;
        const NUM_MAX = data?.inventory > 0 ? data?.inventory : 0;
        const { useState } = useGlobal();
        const [number, setNumber] = useState(data?.quantity ?? 0);
        const isSoldOut = Number(data?.inventory || 0) <= 0 && data?.inventoryPolicy !== 'continue';
        const isPlusDisabled = number >= NUM_MAX || isSoldOut;
        const reduceNumber = () => {
            if (number <= NUM_MIN || isSoldOut) return false;
            setNumber(number - 1);
            callback(data, number - 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_remove_from_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number - 1,
                    button_name: '-',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const addNumber = () => {
            if (isPlusDisabled) {
                return false;
            }
            setNumber(number + 1);
            callback(data, number + 1);
            try {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'bundle_add_to_cart',
                    product_name: data?.name,
                    price: data?.discountPrice,
                    quantity: number + 1,
                    button_name: '+',
                    list_name: 'none',
                    tag: 'none',
                });
            } catch (e) {
                console.error(e);
            }
        };

        const inputChange = (e: any) => {
            if (isSoldOut) return;
            const v = e.target.value.replace(/[^0-9]/g, '');
            if (v < NUM_MIN || v > NUM_MAX) {
                return;
            }
            setNumber(Number(v));
            callback(data, Number(v));
        };

        const addButton = (
            <div className={isPlusDisabled ? 'addSubtractor-add disable' : 'addSubtractor-add'} onClick={isPlusDisabled ? undefined : addNumber}>
                <ICON_2 />
            </div>
        );

        return (
            <div className="bundle-calculator">
                <div className={number <= NUM_MIN || isSoldOut ? 'addSubtractor-reduce disable' : 'addSubtractor-reduce'} onClick={reduceNumber}>
                    <ICON_1 />
                </div>
                <input className="addSubtractor-number" value={number} onChange={inputChange} />
                {isPlusDisabled ? (
                    <Tooltip title={t('item_maximum_purchase_quantity')} trigger="click">
                        {addButton}
                    </Tooltip>
                ) : (
                    addButton
                )}
            </div>
        );
    };

    return (
        <div id="RV-F11" className={`RV-F RV-box ${css['RV-F']}`} ref={moduleFRef}>
            <div className="info-box">
                <p className="title">{t('F_title')}</p>
                {EU_SITES?.includes(locale) && <p className="desc">{t('F_desc')}</p>}
            </div>
            <div className="tabs-wrapper" style={{ top: `${top}px` }}>
                <div className="tabs-box">
                    <ul className="tabs">
                        {tabs?.map((tab: string, k: number) => (
                            <li className={`tab ${active === tab ? 'active' : ''}`} key={tab} onClick={() => handleClickTab(tab, k)}>
                                {tab}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            {!['us', 'ca'].includes(locale) && (
                <div className="img-box">
                    <EFPicture
                        src={EU_SITES?.includes(locale) ? IMG_MAP.us[img - 1] : locale === 'au' ? IMG_MAP[locale][img - 1] : IMG_MAP['us'][img]}
                        alt={t(`F_tab${EU_SITES?.includes(locale) ? img - 1 : img}`)}
                    />
                </div>
            )}
            <ul className="products">
                {curProducts?.map((product: any, k: number) => (
                    <Fragment key={`${img}_${k}`}>
                        {!product.hidden && (
                            <li className="product">
                                <div className="product-content">
                                    {product?.tag && !['za', ...EU_SITES].includes(locale) && (
                                        <span className={`product-tag ${img === 4 && k === 0 ? 'free' : ''}`}>
                                            {t.rich(product.tag, {
                                                s: (text: string) => <span className="s">{text}</span>,
                                            })}
                                        </span>
                                    )}
                                    {EU_SITES.includes(locale) && product.discountPrice !== product.originalPrice && (
                                        <span className={`product-tag`}>
                                            {t.rich('F_off', {
                                                v: `${Math.floor(100 - (product.discountPrice / product.originalPrice) * 100)}%`,
                                                s: (text: string) => <span className="s">{text}</span>,
                                            })}
                                        </span>
                                    )}
                                    {locale !== 'au' && <p className="product-title">{product.title}</p>}
                                    <div className="product-img">
                                        <EFPicture src={product.img} alt={product.title} />
                                    </div>
                                    <div className="product-info">
                                        <p className="product-name">{product.name}</p>
                                        <p className="product-power">{product.power}</p>
                                        <p className="product-desc">{product.desc}</p>
                                        {locale !== 'kr' && product?.sub && (locale !== 'au' || AU_ENTER_LAUNCH_FLAG) && (
                                            <div className="product-sub">
                                                {product.question && <p className="product-question">{product.question}</p>}
                                                <div className="sub-box">
                                                    <div className="sub-img">
                                                        <EFPicture src={product.sub.img} alt={product.sub.name} />
                                                    </div>
                                                    <div className="sub-info">
                                                        <p className="sub-name">{product.sub.name}</p>
                                                        {!getComingSoonState(product?.comingSoon) && (
                                                            <div className="sub-price">
                                                                <span className="price-discount">{FormatMoneyLocal(product.sub.discountPrice, locale)}</span>
                                                                {product.sub.discountPrice !== product.sub.originalPrice && (
                                                                    <span className="price-original">
                                                                        {FormatMoneyLocal(product.sub.originalPrice, locale)}
                                                                    </span>
                                                                )}
                                                            </div>
                                                        )}
                                                        {product.sub.discountPrice !== product.sub.originalPrice &&
                                                            !getComingSoonState(product?.comingSoon) && (
                                                                <p className="price-save">
                                                                    {t.rich('F_save', {
                                                                        save: FormatMoneyLocal(
                                                                            Math.round(100 * (product.sub.originalPrice - product.sub.discountPrice)) / 100,
                                                                            locale,
                                                                        ),
                                                                    })}
                                                                </p>
                                                            )}
                                                    </div>
                                                    {!getComingSoonState(product?.comingSoon) && (
                                                        <AddReduceCalc data={product.sub} callback={handleCalculate} />
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {(locale !== 'au' || AU_ENTER_LAUNCH_FLAG) &&
                                    (getComingSoonState(product?.comingSoon) ? (
                                        <div className="product-bottom">
                                            <button className=" buy-now disable">Coming Soon</button>
                                        </div>
                                    ) : (
                                        <div className="product-bottom">
                                            <div className="total-price">
                                                <span className="total-discount">
                                                    {FormatMoneyLocal(
                                                        product?.discountPrice + (product?.sub?.quantity || 0) * (product?.sub?.discountPrice || 0),
                                                        locale,
                                                    )}
                                                </span>
                                                {product.discountPrice + (product?.sub?.quantity || 0) * (product?.sub?.discountPrice || 0) !==
                                                    product.originalPrice + (product?.sub?.quantity || 0) * (product?.sub?.originalPrice || 0) && (
                                                    <span className="total-original">
                                                        {FormatMoneyLocal(
                                                            product.originalPrice + (product?.sub?.quantity || 0) * (product?.sub?.originalPrice || 0),
                                                            locale,
                                                        )}
                                                    </span>
                                                )}
                                            </div>
                                            {![...EU_SITES, 'kr', 'za'].includes(locale) && (
                                                <div className="install">
                                                    {locale === 'au' ? <ICON_AU /> : <ICON_NA />}
                                                    <span className="install-text">{t('F_install')}</span>
                                                </div>
                                            )}
                                            {['za'].includes(locale) && (
                                                <button className={`learn-more2`} onClick={() => handlerLearnMore(product)}>
                                                    Learn More
                                                </button>
                                            )}
                                            <button
                                                className={`buy-now ${!(EU_SITES.includes(locale) && !IS_LAUNCH) && product?.inventory <= 0 ? 'disable' : ''}`}
                                                onClick={
                                                    !(EU_SITES.includes(locale) && !IS_LAUNCH) && product?.inventory <= 0 ? undefined : () => handleBuy(product)
                                                }
                                            >
                                                {EU_SITES.includes(locale) && !IS_LAUNCH
                                                    ? t('F_more')
                                                    : getBuyNowPreOrder(product)
                                                    ? t('F_preorder')
                                                    : product?.inventory > 0
                                                    ? t('F_buy')
                                                    : t('F_soldout')}
                                            </button>
                                            {['us', 'ca'].includes(locale) && (
                                                <button className="learn-more3" onClick={() => handlerLearnMore(product)}>
                                                    {t('F_learn')}
                                                </button>
                                            )}
                                        </div>
                                    ))}
                            </li>
                        )}
                    </Fragment>
                ))}
            </ul>
            {IS_LAUNCH && !['us', 'ca'].includes(locale) && <p className="ship">{t('F_ship')}</p>}
        </div>
    );
}
